import { event } from '@uhg-abyss/web/tools/event';
// import { config } from '@uhg-abyss/web/tools/config';

// const environment = config('APP_ENV');

// NOTE :: leaving dynatrace integration commented out for now since we will be adding that soon
export const setPageHandler = (pageName, group) => {
  // const dynatrace = window?.dtrum || { setPage: () => {} }; // Fallback in case dynatrace is not available
  // const pageGroup = `${group || 'digisec'}-${environment}`; // ex: digisec-stage

  if (typeof event?.setData === 'function') {
    event.setData({ pageName: pageName }); // for adobe page tagging
  }
  // dynatrace?.setPage({ name: pageName, group: pageGroup }); // for dynatrace { name: 'my-page', group: 'digisec-<env>' }
};
